export enum MenuItemStatus{
  Available = "A",
  Unavailable = "U",
  Hide = "H",
  NoAdvanceOrder = "N"
}
